import { SelectPicker } from 'rsuite';

import './Select.css';

const filterUniqueTypes = (skus, type, sku) => {
  if (!skus || typeof skus[Symbol.iterator] !== 'function') {
    // SKUS is empty or is not iterable
    return skus;
  }

  const uniqueTypes = new Set();
  uniqueTypes.add(sku[type]);

  const filtered = [sku];

  for (const eachSku of skus) {
    if (!uniqueTypes.has(eachSku[type])) {
      uniqueTypes.add(eachSku[type]);
      filtered.push(eachSku);
    }
  }

  return filtered;
}

const skuSort = (a, b) => Number(a.id) - Number(b.id);

const Select = (props) => {
  const { skus, onChange, label, type, placeholder, sku } = props;

  let uniqueSkus = skus;

  if (type === 'size') {
    uniqueSkus = filterUniqueTypes(skus, type, sku);
  }

  if (type === 'color') {
    uniqueSkus = skus.filter(eachSku => eachSku.size === sku.size);
  }

  const data = uniqueSkus.sort(skuSort).map(sku => ({value: sku.strId, label: sku[type], type: type }))

  return (
    <div className="rntr-select">
      <div className="rntr-select__title">{ label }</div>
      <SelectPicker
        data={data}
        searchable={false}
        onChange={onChange}
        classPrefix='rntr-input'
        menuClassName='rntr-menu'
        cleanable={false}
        value={sku.strId}
        placeholder={placeholder}/>
    </div>
  );
}

export default Select;
